<script>
    export let dialogMessage;
    export let dialogType;
</script>
<div class="notification is-light has-text-centered has-text-wight-bold is-size-4 {dialogType}">
    { dialogMessage }
</div>